import { c as _c } from "react/compiler-runtime";
import { CurrencyEnum, FormInput, FormInputSearch, Tooltip, centsToUnits, units } from '@systemeio/ui';
import { createTag, removeTag, updateTag } from 'modules/tags/api/tags-api';
import TagStatisticSkeleton from 'modules/tags/components/tag-statistic-skeleton';
import { TagsLoco } from 'modules/tags/constants/tags-loco';
import { useTags } from 'modules/tags/hooks/use-tags';
import { TagFilterInterface } from 'modules/tags/types/tag-filter-interface';
import { TagCreateInterface, TagErrorsInterface, TagInterface } from 'modules/tags/types/tag-interface';
import { getTagStatistic } from 'modules/tags/utils/get-tag-statistic';
import { NextPage } from 'next';
import React, { useState } from 'react';
import { CreateDataType } from 'shared/components/create-modal';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import ListingLayout from 'shared/components/listing-layout';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { useFilterPagination } from 'shared/route-query/hooks/use-filter-pagination';
import { OrderEnum } from 'shared/types/pagination-interface';
import { currencyFormat } from 'shared/utils/currency-format';
import { fetchWithErrors } from 'shared/utils/fetch-with-errors';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';
const defaultValues: TagCreateInterface = {
  name: ''
};
const defaultErrors: TagErrorsInterface = {
  name: ''
};
const defaultFilters: TagFilterInterface = {
  searchBy: ''
};
const Tag: NextPage = () => {
  const $ = _c(165);
  const {
    user,
    isWsAssistant
  } = useUser();
  const {
    filter,
    setFilter,
    setPagination,
    pagination,
    setLimit,
    limit
  } = useFilterPagination(defaultFilters);
  const [errors, setErrors] = useState(defaultErrors);
  const {
    t
  } = useLocoTranslation();
  let t0;
  if ($[0] !== filter || $[1] !== limit || $[2] !== pagination) {
    t0 = {
      limit,
      pagination,
      filter
    };
    $[0] = filter;
    $[1] = limit;
    $[2] = pagination;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const {
    tags,
    tagsStatistics,
    mutate,
    counter,
    revalidateTagsModule
  } = useTags(t0);
  let t1;
  if ($[4] !== t) {
    t1 = t("dashboard.tag.tag_name");
    $[4] = t;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== isWsAssistant) {
    t2 = tag => <div className="truncate">{isWsAssistant ? <span className="w-full">{tag.name}</span> : <LinkWithoutPrefetch className="primary-link w-full" href={`/contacts?filter=%5B%7B"searchValue"%3A"${tag.id}"%2C"compareOperation"%3A"IN_LIST"%2C"searchField"%3A"tag"%7D%5D`}>{tag.name}</LinkWithoutPrefetch>}</div>;
    $[6] = isWsAssistant;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t1 || $[9] !== t2) {
    t3 = {
      key: "name",
      header: t1,
      widthPercent: 30,
      onRender: t2
    };
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t) {
    t4 = t("dashboard.tag.sub_today");
    $[11] = t;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t) {
    t5 = t("dashboard.tag.today");
    $[13] = t;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t5) {
    t6 = <span className="truncate">{t5}</span>;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t4 || $[18] !== t6) {
    t7 = <Tooltip mode="hover" label={t4} wrapperClassName="w-full">{t6}</Tooltip>;
    $[17] = t4;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== tagsStatistics) {
    t8 = tag_0 => <>{getTagStatistic(tag_0, tagsStatistics)?.today ?? <TagStatisticSkeleton />}</>;
    $[20] = tagsStatistics;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t7 || $[23] !== t8) {
    t9 = {
      key: "statistics.today",
      header: t7,
      widthPercent: 15,
      onRender: t8
    };
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t) {
    t10 = t("dashboard.tag.sub_yesterday");
    $[25] = t;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t) {
    t11 = t("dashboard.tag.yesterday");
    $[27] = t;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t11) {
    t12 = <span className="truncate">{t11}</span>;
    $[29] = t11;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t10 || $[32] !== t12) {
    t13 = <Tooltip mode="hover" label={t10} wrapperClassName="w-full">{t12}</Tooltip>;
    $[31] = t10;
    $[32] = t12;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== tagsStatistics) {
    t14 = tag_1 => <>{getTagStatistic(tag_1, tagsStatistics)?.yesterday ?? <TagStatisticSkeleton />}</>;
    $[34] = tagsStatistics;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== t13 || $[37] !== t14) {
    t15 = {
      key: "statistics.yesterday",
      header: t13,
      widthPercent: 15,
      onRender: t14
    };
    $[36] = t13;
    $[37] = t14;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== t) {
    t16 = t("dashboard.tag.sub_total");
    $[39] = t;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] !== t) {
    t17 = t("dashboard.tag.total");
    $[41] = t;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== t17) {
    t18 = <span className="truncate">{t17}</span>;
    $[43] = t17;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] !== t16 || $[46] !== t18) {
    t19 = <Tooltip mode="hover" label={t16} wrapperClassName="w-full">{t18}</Tooltip>;
    $[45] = t16;
    $[46] = t18;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  let t20;
  if ($[48] !== tagsStatistics) {
    t20 = tag_2 => <>{getTagStatistic(tag_2, tagsStatistics)?.totalAdded ?? <TagStatisticSkeleton />}</>;
    $[48] = tagsStatistics;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  let t21;
  if ($[50] !== t19 || $[51] !== t20) {
    t21 = {
      key: "statistics.totalAdded",
      header: t19,
      widthPercent: 15,
      onRender: t20
    };
    $[50] = t19;
    $[51] = t20;
    $[52] = t21;
  } else {
    t21 = $[52];
  }
  let t22;
  if ($[53] !== t) {
    t22 = t("dashboard.tag.sub_removed");
    $[53] = t;
    $[54] = t22;
  } else {
    t22 = $[54];
  }
  let t23;
  if ($[55] !== t) {
    t23 = t("dashboard.tag.unsubscribed");
    $[55] = t;
    $[56] = t23;
  } else {
    t23 = $[56];
  }
  let t24;
  if ($[57] !== t23) {
    t24 = <span className="truncate">{t23}</span>;
    $[57] = t23;
    $[58] = t24;
  } else {
    t24 = $[58];
  }
  let t25;
  if ($[59] !== t22 || $[60] !== t24) {
    t25 = <Tooltip mode="hover" label={t22} wrapperClassName="w-full">{t24}</Tooltip>;
    $[59] = t22;
    $[60] = t24;
    $[61] = t25;
  } else {
    t25 = $[61];
  }
  let t26;
  if ($[62] !== tagsStatistics) {
    t26 = tag_3 => <>{getTagStatistic(tag_3, tagsStatistics)?.totalRemoved ?? <TagStatisticSkeleton />}</>;
    $[62] = tagsStatistics;
    $[63] = t26;
  } else {
    t26 = $[63];
  }
  let t27;
  if ($[64] !== t25 || $[65] !== t26) {
    t27 = {
      key: "statistics.totalRemoved",
      header: t25,
      widthPercent: 15,
      onRender: t26
    };
    $[64] = t25;
    $[65] = t26;
    $[66] = t27;
  } else {
    t27 = $[66];
  }
  let t28;
  if ($[67] !== t) {
    t28 = t("dashboard.tag.total_sales");
    $[67] = t;
    $[68] = t28;
  } else {
    t28 = $[68];
  }
  let t29;
  if ($[69] !== t || $[70] !== tagsStatistics || $[71] !== user?.dashboardLocale) {
    t29 = tag_4 => {
      const statistic = getTagStatistic(tag_4, tagsStatistics);
      if (!statistic) {
        return <TagStatisticSkeleton />;
      }
      return <>{statistic.salesAmount.length !== 0 ? <Tooltip mode="hover" label={<div className="flex flex-col gap-1.5"><span className="text-text-primary font-bold">{t("dashboard.tag.sales_before_refunds")}</span>{statistic.salesAmount.map((el, idx) => <span key={idx}>{currencyFormat(centsToUnits(el.refunded), el.currency, user?.dashboardLocale)}</span>)}</div>}><div className="flex flex-col gap-1.5">{statistic.salesAmount.map((el_0, idx_0) => <span key={idx_0}>{currencyFormat(centsToUnits(el_0.notRefunded), el_0.currency, user?.dashboardLocale)}</span>)}</div></Tooltip> : currencyFormat(units(0), CurrencyEnum.EURO, user?.dashboardLocale)}</>;
    };
    $[69] = t;
    $[70] = tagsStatistics;
    $[71] = user?.dashboardLocale;
    $[72] = t29;
  } else {
    t29 = $[72];
  }
  let t30;
  if ($[73] !== t28 || $[74] !== t29) {
    t30 = {
      key: "statistics.salesAmount",
      header: t28,
      widthPercent: 20,
      onRender: t29
    };
    $[73] = t28;
    $[74] = t29;
    $[75] = t30;
  } else {
    t30 = $[75];
  }
  let t31;
  if ($[76] !== t) {
    t31 = t("dashboard.tag.sales_per_contact");
    $[76] = t;
    $[77] = t31;
  } else {
    t31 = $[77];
  }
  let t32;
  if ($[78] !== t || $[79] !== tagsStatistics || $[80] !== user?.dashboardLocale) {
    t32 = tag_5 => {
      const statistic_0 = getTagStatistic(tag_5, tagsStatistics);
      if (!statistic_0) {
        return <TagStatisticSkeleton />;
      }
      return <>{statistic_0.averageSales.length !== 0 ? <Tooltip mode="hover" label={<div className="flex flex-col gap-1.5"><span className="text-text-primary font-bold">{t("dashboard.tag.sales_before_refunds")}</span>{statistic_0.averageSales.map((el_1, idx_1) => <span key={idx_1}>{currencyFormat(centsToUnits(el_1.refunded), el_1.currency, user?.dashboardLocale)}</span>)}</div>}><div className="flex flex-col gap-1.5">{statistic_0.averageSales.map((el_2, idx_2) => <span key={idx_2}>{currencyFormat(centsToUnits(el_2.notRefunded), el_2.currency, user?.dashboardLocale)}</span>)}</div></Tooltip> : currencyFormat(units(0), CurrencyEnum.EURO, user?.dashboardLocale)}</>;
    };
    $[78] = t;
    $[79] = tagsStatistics;
    $[80] = user?.dashboardLocale;
    $[81] = t32;
  } else {
    t32 = $[81];
  }
  let t33;
  if ($[82] !== t31 || $[83] !== t32) {
    t33 = {
      key: "statistics.averageSales",
      header: t31,
      widthPercent: 20,
      onRender: t32
    };
    $[82] = t31;
    $[83] = t32;
    $[84] = t33;
  } else {
    t33 = $[84];
  }
  let t34;
  if ($[85] !== t15 || $[86] !== t21 || $[87] !== t27 || $[88] !== t3 || $[89] !== t30 || $[90] !== t33 || $[91] !== t9) {
    t34 = [t3, t9, t15, t21, t27, t30, t33];
    $[85] = t15;
    $[86] = t21;
    $[87] = t27;
    $[88] = t3;
    $[89] = t30;
    $[90] = t33;
    $[91] = t9;
    $[92] = t34;
  } else {
    t34 = $[92];
  }
  const columns = t34;
  let t35;
  if ($[93] !== revalidateTagsModule || $[94] !== setPagination) {
    t35 = async tag_6 => {
      await removeTag(tag_6.id);
      revalidateTagsModule(true);
      setPagination({
        order: OrderEnum.next
      });
    };
    $[93] = revalidateTagsModule;
    $[94] = setPagination;
    $[95] = t35;
  } else {
    t35 = $[95];
  }
  const onRemoveTag = t35;
  let t36;
  if ($[96] !== revalidateTagsModule || $[97] !== setPagination) {
    t36 = async data => {
      await fetchWithErrors(async () => {
        await createTag(data);
        revalidateTagsModule(true);
        setPagination({
          order: OrderEnum.next
        });
      }, setErrors);
    };
    $[96] = revalidateTagsModule;
    $[97] = setPagination;
    $[98] = t36;
  } else {
    t36 = $[98];
  }
  const onCreateTag = t36;
  let t37;
  if ($[99] !== mutate || $[100] !== revalidateTagsModule) {
    t37 = async (tag_7, newData) => {
      await fetchWithErrors(async () => {
        await updateTag(tag_7.id, newData);
        await mutate(data_0 => {
          if (data_0) {
            return {
              items: data_0.items.map(item => {
                if (item.id === tag_7.id) {
                  item = {
                    ...item,
                    ...newData
                  };
                }
                return item;
              }),
              hasMore: data_0.hasMore
            };
          }
        }, false);
        revalidateTagsModule();
      }, setErrors);
    };
    $[99] = mutate;
    $[100] = revalidateTagsModule;
    $[101] = t37;
  } else {
    t37 = $[101];
  }
  const onUpdateTag = t37;
  let t38;
  if ($[102] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = () => setErrors(defaultErrors);
    $[102] = t38;
  } else {
    t38 = $[102];
  }
  const onModalClose = t38;
  let t39;
  if ($[103] !== t) {
    t39 = t("dashboard.tag.title_plural");
    $[103] = t;
    $[104] = t39;
  } else {
    t39 = $[104];
  }
  let t40;
  if ($[105] !== filter || $[106] !== setFilter) {
    t40 = {
      filter,
      setFilter,
      defaultFilters
    };
    $[105] = filter;
    $[106] = setFilter;
    $[107] = t40;
  } else {
    t40 = $[107];
  }
  let t41;
  if ($[108] !== pagination || $[109] !== setPagination) {
    t41 = {
      pagination,
      setPagination
    };
    $[108] = pagination;
    $[109] = setPagination;
    $[110] = t41;
  } else {
    t41 = $[110];
  }
  let t42;
  if ($[111] !== limit || $[112] !== setLimit) {
    t42 = {
      limit,
      setLimit
    };
    $[111] = limit;
    $[112] = setLimit;
    $[113] = t42;
  } else {
    t42 = $[113];
  }
  let t43;
  if ($[114] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = [{
      field: "searchBy",
      onRender: _temp
    }];
    $[114] = t43;
  } else {
    t43 = $[114];
  }
  let t44;
  if ($[115] !== t40 || $[116] !== t41 || $[117] !== t42) {
    t44 = {
      filterer: t40,
      paginator: t41,
      limiter: t42,
      filterable: t43
    };
    $[115] = t40;
    $[116] = t41;
    $[117] = t42;
    $[118] = t44;
  } else {
    t44 = $[118];
  }
  let t45;
  if ($[119] !== onCreateTag) {
    t45 = data_1 => onCreateTag(data_1);
    $[119] = onCreateTag;
    $[120] = t45;
  } else {
    t45 = $[120];
  }
  let t46;
  if ($[121] !== t) {
    t46 = t("dashboard.tag.title");
    $[121] = t;
    $[122] = t46;
  } else {
    t46 = $[122];
  }
  let t47;
  if ($[123] === Symbol.for("react.memo_cache_sentinel")) {
    t47 = ["name"];
    $[123] = t47;
  } else {
    t47 = $[123];
  }
  let t48;
  if ($[124] !== errors || $[125] !== t) {
    t48 = [{
      field: "name",
      onRender: (value_0, onChange_0) => <FormInput key="tag-name-create" label={t("dashboard.tag.tag_name")} placeholder={t("global.name")} value={value_0} onChange={e_0 => onChange_0(e_0.target.value)} maxLength={256} error={errors.name} />
    }];
    $[124] = errors;
    $[125] = t;
    $[126] = t48;
  } else {
    t48 = $[126];
  }
  let t49;
  if ($[127] !== t45 || $[128] !== t46 || $[129] !== t48) {
    t49 = {
      onCreate: t45,
      defaultValues,
      caption: t46,
      onAfterLeave: onModalClose,
      requiredFields: t47,
      creatable: t48
    };
    $[127] = t45;
    $[128] = t46;
    $[129] = t48;
    $[130] = t49;
  } else {
    t49 = $[130];
  }
  let t50;
  if ($[131] !== t) {
    t50 = t("dashboard.tag.title");
    $[131] = t;
    $[132] = t50;
  } else {
    t50 = $[132];
  }
  let t51;
  if ($[133] !== limit || $[134] !== setLimit) {
    t51 = {
      limit,
      setLimit
    };
    $[133] = limit;
    $[134] = setLimit;
    $[135] = t51;
  } else {
    t51 = $[135];
  }
  let t52;
  if ($[136] !== pagination || $[137] !== setPagination) {
    t52 = {
      pagination,
      setPagination
    };
    $[136] = pagination;
    $[137] = setPagination;
    $[138] = t52;
  } else {
    t52 = $[138];
  }
  let t53;
  if ($[139] !== errors) {
    t53 = [{
      field: "name",
      onRender: (value_1, onChange_1) => <FormInput key="tag-name-edit" label="" value={value_1} onChange={e_1 => onChange_1(e_1.target.value)} error={errors.name} />
    }];
    $[139] = errors;
    $[140] = t53;
  } else {
    t53 = $[140];
  }
  let t54;
  if ($[141] !== onUpdateTag) {
    t54 = (tag_8, data_2) => onUpdateTag(tag_8, data_2);
    $[141] = onUpdateTag;
    $[142] = t54;
  } else {
    t54 = $[142];
  }
  let t55;
  if ($[143] !== t53 || $[144] !== t54) {
    t55 = {
      onModalClose,
      editable: t53,
      onEdit: t54
    };
    $[143] = t53;
    $[144] = t54;
    $[145] = t55;
  } else {
    t55 = $[145];
  }
  let t56;
  if ($[146] !== onRemoveTag) {
    t56 = {
      onChange: tag_9 => onRemoveTag(tag_9)
    };
    $[146] = onRemoveTag;
    $[147] = t56;
  } else {
    t56 = $[147];
  }
  let t57;
  if ($[148] !== t55 || $[149] !== t56) {
    t57 = {
      settings: t55,
      remove: t56
    };
    $[148] = t55;
    $[149] = t56;
    $[150] = t57;
  } else {
    t57 = $[150];
  }
  let t58;
  if ($[151] !== columns || $[152] !== t50 || $[153] !== t51 || $[154] !== t52 || $[155] !== t57 || $[156] !== tags) {
    t58 = <Table data={tags} columns={columns} caption={t50} limiter={t51} paginator={t52} actions={t57} />;
    $[151] = columns;
    $[152] = t50;
    $[153] = t51;
    $[154] = t52;
    $[155] = t57;
    $[156] = tags;
    $[157] = t58;
  } else {
    t58 = $[157];
  }
  let t59;
  if ($[158] !== counter || $[159] !== t39 || $[160] !== t44 || $[161] !== t49 || $[162] !== t58 || $[163] !== tags) {
    t59 = <ListingLayout counter={counter} data={tags} title={t39} type="compact" filterData={t44} createData={t49}>{t58}</ListingLayout>;
    $[158] = counter;
    $[159] = t39;
    $[160] = t44;
    $[161] = t49;
    $[162] = t58;
    $[163] = tags;
    $[164] = t59;
  } else {
    t59 = $[164];
  }
  return t59;
};
export const getServerSideProps = getBaseServerSideProps(TagsLoco, 'header.top_menu.tags');
export default Tag;
function _temp(value, onChange) {
  return <FormInputSearch key="tag-search-filter" onClear={() => onChange("")} value={value} onChange={e => onChange(e.target.value)} />;
}